export default __webpack_public_path__ + "static/media/eduOrange.d99ad3eb.jpg";